import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import ContentSection from './ContentSection';
import FooterSection from './FooterSection';

// HomePage combines Hero + Content sections
function HomePage() {
  return (
    <>
      <HeroSection />
      <ContentSection />
    </>
  );
}

// Placeholder pages - will be built out next
function ServicesPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Our Services</h1>
        <p>Comprehensive field marketing solutions</p>
      </div>
    </div>
  );
}

function ResultsPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Proven Results</h1>
        <p>Real campaigns, real numbers</p>
      </div>
    </div>
  );
}

function AboutPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>About IXL Marketing</h1>
        <p>15 years of field marketing excellence</p>
      </div>
    </div>
  );
}

function ContactPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Contact Us</h1>
        <p>Let's discuss your field marketing needs</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <FooterSection />
      </div>
    </Router>
  );
}

export default App;
